export const PATHS = {
    MAIN: "/",
    PRIVACY: "/privacy",
};
